import { Component } from "vue";
import { generateFlags } from "@/src/design_system/primitives/flag/utils/flagComponentManager";
import { DSFlagName } from "@/src/design_system/primitives/flag/types/flagName";
import { FLAGS } from "@/src/design_system/primitives/flag/constants/flags";

export const getSvgComponentLoader = (flagName: DSFlagName): Component | null => {
  const flagToSvgMap = generateFlags(FLAGS);
  const componentLoader = flagToSvgMap[flagName];

  if (!componentLoader) {
    console.error(`missing svg file for flag ${flagName as string}`);
  }

  return componentLoader || null;
};
